/**
 * Elasticsearch `query_string` syntax characters. The API builds its searches with
 * `query_string` + `analyze_wildcard`, so anything typed by a person and left unescaped
 * either fails the search outright (the resolver errors and the caller shows an empty
 * list) or silently changes what was asked for: `!` becomes NOT, `~` becomes fuzzy, `:`
 * starts a new field clause. Escape with `value.replace(ES_SPECIAL_CHARS, `\\$&`)`;
 * unlike `sanitizeValue` that keeps digits.
 */
export const ES_SPECIAL_CHARS = /[+\-=&|><!(){}[\]^"~*?:\\/]/g
